import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TableHeader from "./TableHeader";
import { useEffect, useMemo, useState } from "react";
import {
  Checkbox,
  IconButton,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const DataTable = ({
  rows,
  selected,
  setSelected,
  loading,
}) => {
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("state_id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(()=>{
    if (rows) {
      setPage(0)
    }
  },[rows])

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setPage(0);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const sortedRows = useMemo(
    () => [...rows].sort(getComparator(order, orderBy)),
    [rows, order, orderBy]
  );

  const visibleRows = useMemo(
    () => sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [sortedRows, page, rowsPerPage]
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <Table>
        <TableHeader
          numSelected={selected.length}
          order={order}
          orderBy={orderBy}
          onSelectAllClick={handleSelectAllClick}
          onRequestSort={handleRequestSort}
          rowCount={rows.length}
        />
        <TableBody>
          {visibleRows.map((row, index) => {
            const isItemSelected = selected.includes(row.id);
            const labelId = `enhanced-table-checkbox-${index}`;

            return (
              <TableRow
                hover
                onClick={(event) => handleClick(event, row.id)}
                role="checkbox"
                aria-checked={isItemSelected}
                tabIndex={-1}
                key={row.id}
                selected={isItemSelected}
                sx={{ cursor: "pointer" }}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    checked={isItemSelected}
                    inputProps={{
                      "aria-labelledby": labelId,
                    }}
                  />
                </TableCell>
                <TableCell align="left">{row.utility_code}</TableCell>
                <TableCell align="left">{row.utility_name}</TableCell>
                <TableCell align="left">{row.state_id}</TableCell>
                <TableCell align="left">{row.commodity}</TableCell>
                <TableCell align="left">{row.class}</TableCell>
                <TableCell align="left">{row.last_ptc_updated}</TableCell>
                <TableCell align="left">{row.has_start_date}</TableCell>
                <TableCell align="left">{row.has_end_date}</TableCell>
                <TableCell align="left">{row.original_price}</TableCell>
                <TableCell align="left">{row.ptc_rate}</TableCell>
                <TableCell align="left">{row.uom}</TableCell>
                <TableCell align="left">
                  {new Date(row.last_updated).toLocaleDateString()}
                </TableCell>
                <TableCell align="left">
                  {row.source !== "" && (
                    <IconButton
                      component="a"
                      href={row.source.startsWith("http") ? row.source : `https://${row.source}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <OpenInNewIcon />
                    </IconButton>
                  )}
                </TableCell>
                <TableCell align="left">
                  <p>
                      {row.graduated_standard_rate && (
                        Object.keys(row.graduated_standard_rate)
                          .filter(key => key) 
                          .map(key => {
                            let min;
                            if (key.includes('~')) {
                              min = parseInt(key.split('~')[0], 10) || 0;
                            } else if (key.startsWith('>')) {
                              min = parseInt(key.slice(1), 10) || 0;
                            } else {
                              min = Infinity; 
                            }
                            return { key, min };
                          })
                          .sort((a, b) => a.min - b.min)
                          .map(item => (
                            <p key={item.key}>
                              {item.key}: {row.graduated_standard_rate[item.key]}
                            </p>
                          ))
                      )}
                  </p>
                </TableCell>
                {/* <TableCell align="left">
                  {row.period ?
                  `Start Date: ${row.period.match(/"start_date":"([^"]+)"/)[1]},
                   End Date: ${row.period.match(/"end_date":"([^"]+)"/)[1]}`
                  :
                  ``
                  }
                </TableCell> */}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default DataTable;